import React from "react";
import { Container } from "react-bootstrap";
import { Base } from "../../components/RootLayout";
import { iconArrowLeft } from "../../utils/svg_assets";
import { privacy_policy } from "./privacy_policy";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <Base>
      <Container
        style={{
          padding: "2rem",
          textAlign: "justify",
        }}
        dangerouslySetInnerHTML={{ __html: privacy_policy }}
      />
      <div className="close-btn" onClick={() => navigate(-1)}>
        <img src={iconArrowLeft} width="24pt" height="24pt" alt="arrow-back" />
      </div>
    </Base>
  );
}
